import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { AccordionModule } from 'primeng/accordion';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InsuranceTypeService } from 'src/app/dashboard/insurance/insurance-type/insurance-type.service';
import { InsuranceType } from 'src/app/dashboard/insurance/insurance-type/insurance-type.model';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-featured-insurance',
  standalone: true,
  imports: [
    CommonModule,
    DividerModule,
    AccordionModule,
    CardModule,
    ButtonModule,
    RouterModule,
  ],
  templateUrl: './featured-insurance.component.html',
  styleUrl: './featured-insurance.component.scss',
})
export class FeaturedInsuranceComponent {
  insuranceTypeService = inject(InsuranceTypeService);
  sectionInsuranceList: InsuranceType[] = [];

  constructor(private router: Router) {
    this.insuranceTypeService.getPublicTypeList().subscribe(response => {
      console.log('RESPONSE', response);

      const images = [
        'buceadores-recreativos.jpg',
        'centros-buceo.jpg',
        'buceo-profesional.jpg',
        'instructores-divemasters.jpg',
      ];
      const updated = response.map((element: any, index: number) => {
        return { ...element, image_url: images[index] };
      });

      this.sectionInsuranceList = updated;
    });
  }
}
